import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Car, Clock } from "lucide-react";

const AdvancedParkingSolutions = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-8">
      <div className="max-w-5xl mx-auto">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          className="mb-6 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <img src="/zkteco-logo.png" alt="ZKTeco" className="h-24 w-auto" />
          </div>
          <h1 className="text-3xl font-bold text-slate-800 mb-2">
            Advanced Parking Solutions
          </h1>
          <p className="text-lg text-slate-600">
            Parking solutions including car park and paid for parking management
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="max-w-lg mx-auto">
          <Card className="border-2 border-slate-200 overflow-hidden">
            <CardContent className="p-0">
              <div className="h-64 bg-gradient-to-br from-emerald-500 to-teal-600 flex flex-col items-center justify-center text-white relative">
                {/* Coming Soon Badge */}
                <div className="absolute top-4 right-4">
                  <div className="px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-sm font-semibold flex items-center gap-2">
                    <Clock className="h-4 w-4" />
                    Coming Soon
                  </div>
                </div>

                {/* Icon */}
                <div className="mb-4">
                  <div className="w-20 h-20 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center">
                    <Car className="h-10 w-10" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold mb-2">Advanced Parking</h3>
                <p className="text-white/80 text-center px-6">
                  Car park management and paid parking solutions coming soon
                </p>
              </div>
            </CardContent>
          </Card>

          <p className="text-center text-slate-500 mt-6">
            We are working on bringing you advanced parking management solutions.
            <br />
            Check back soon for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdvancedParkingSolutions;
